export default __webpack_public_path__ + "static/media/popcorn_game_game_title.d6f7ca35.png";